import { Icon } from "@synergy/icons";
import { Col, Flex, Row } from "antd";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import query from "../../../../../server/constants.api";
import logger from "../../../../../server/server";
import useFetch from "../../../../../server/useFetch";
import { Field, PageContent } from "../../../../../styles/global/Pages.styled";
import Theme from "../../../../../styles/Theme/Theme";
import { fullMetrics } from "../../../../../utils/dummydata";
import { toPascalCase } from "../../../../../utils/hooks/toPascalCase";
import { orbitCamera } from "../../../../../utils/renders/render-helper";
import Spinner from "../../../Atomics/Spinner";
import { Text } from "../../../Atomics/Text";
import { Widget } from "../../../Atomics/Widget";
import { RegisterMapComponent } from "../../../Organism/Maps/RegisterMapComponent";
import { FloorVacancyComponent } from "../../FloorVacancyComponent/FloorVacancyComponent";
import { StackedFloorsComponent } from "../../StackedFloorsComponent/StackedFloorsComponent";

const MapWrapper = styled.div`
  height: 200px;
`;

export const BuildingDetail = ({ item, currentFloor, ...props }) => {
    // Obtém a função de tradução do hook useTranslation para uso na tradução de textos
    const { t } = useTranslation();
    const [datePeriod] = useState(null); //State do filtro de periodos
    const [showMore, setShowMore] = useState(false); //State para mostrar mais ou menos dados do building
    const [infoChoosen, setInfoChoosen] = useState("occupation");
    const [orbitCameraVal, setOrbitCamera] = useState(false);
    const [orbitControls, setOrbitControls] = useState();
    const [filteredBuilding, setFilteredBuilding] = useState();
    useEffect(() => {
        logger.info("User entered BuildingDetail successfully!");
    }, []);
    useEffect(() => {
        setOrbitCamera(false);
    }, [infoChoosen]);

    function toggleCamera() {
        orbitCamera(orbitControls, !orbitCameraVal);
        setOrbitCamera(!orbitCameraVal);
    }

    const { data: overviewIndicators, isFetching: overviewIndicatorsIsFetching, refetch: refetchBuildingOverview } = useFetch(
        "/registry/indicators", "overviewIndicators",
        {
            id: currentFloor?.value,
        },
        currentFloor?.value ?? false, null, query.middlewareURL);

    useEffect(() => {
        if (item) {
            const keysToKeep = [
                "name",
                "Address",
                "location",
                "type",
                "latitude",
                "longitude",
                "Number of Floors",
                "Year of Construction",
                "Capacity",
                "Year of Rehabilitation",
                "Usable Area (m2)",
            ];
            const filtered = Object.keys(item)
                .filter((key) => keysToKeep.includes(key))
                .sort((a, b) => keysToKeep.indexOf(a) - keysToKeep.indexOf(b))
                .reduce((obj, key) => {
                    const pascalCaseKey = toPascalCase(key);
                    obj[pascalCaseKey] = item[key];
                    return obj;
                }, {});

            setFilteredBuilding(filtered);
        }
    }, [item]);

    useEffect(() => {
        refetchBuildingOverview();
    }, [datePeriod, currentFloor]);

    return (
        <PageContent className={clsx('building_room_details', props?.className)}>
            {!overviewIndicatorsIsFetching && filteredBuilding ? (
                <Row gutter={[16, 16]}>
                    <Col span={24} style={{ alignContent: 'center' }}>
                        <Row>
                            <Col span={10}>
                                <h3>
                                    {item?.name} | {t("Overview").toLocaleUpperCase()}
                                </h3>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        {item ?
                            <Row gutter={[16, 16]}>
                                <Col span={16}>
                                    <Row gutter={[16, 16]}>
                                        {Object.keys(filteredBuilding)?.map((key, index) => {
                                            if (index < 6) {
                                                return (
                                                    <Col span={12} key={index} className='d-flex'>
                                                        <Field id={index} $backgroundColor="neutral-3" className='full-width'>
                                                            <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{key}</Text>
                                                            <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{filteredBuilding[key] && filteredBuilding[key] != '' ? filteredBuilding[key] : '-'}</Text>
                                                        </Field>
                                                    </Col>
                                                )
                                            }
                                        })}
                                        {Object.keys(filteredBuilding)?.length > 6 ?
                                            <Col span={24} >
                                                <Flex align="center" justify="center">
                                                    <Flex align="center" justify="center" onClick={() => setShowMore(!showMore)} style={{ cursor: 'pointer' }}>
                                                        <Text $fontColor='blue-4' $fontSize='text_md' $weight='medium' $marginRight="s03">{showMore ? t('seeLess') : t('seeMore')}</Text>
                                                        <Icon icon={showMore ? 'ChevronUp' : 'ChevronDown'} iconsize='sm' color='blue-4' />
                                                    </Flex>
                                                </Flex>
                                            </Col> : null
                                        }
                                    </Row>
                                </Col>
                                <Col span={8}>
                                    <Flex gap={16} vertical="true">
                                        <MapWrapper>
                                            <RegisterMapComponent item={[item]} idQuery='RegisterDetail' idCenter={{ lat: parseFloat(item?.latitude), lng: parseFloat(item?.longitude) }} idZoom={17} mapId={'e1816747e3cd86e6'} configId={'registerDetail'} disableClick={true} />
                                        </MapWrapper>
                                    </Flex>
                                </Col>
                                {showMore ?
                                    Object.keys(filteredBuilding)?.map((key, index) => {
                                        if (index > 6 && key !== 'iconBase64') {
                                            return (
                                                <Col span={8} key={index} className='d-flex'>
                                                    <Field id={index} $backgroundColor="neutral-3" className='full-width'>
                                                        <Text $fontColor='coolgray-10' $fontSize='text_xs' $weight='regular'>{key}</Text>
                                                        <Text $fontColor='coolgray-12' $fontSize='text_md' $weight='regular'>{filteredBuilding[key] && filteredBuilding[key] != '' ? filteredBuilding[key] : '-'}</Text>
                                                    </Field>
                                                </Col>
                                            )
                                        }
                                    })
                                    : null
                                }
                            </Row>
                            : null}
                    </Col>
                    <Col span={24}>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Widget
                                    data={{
                                        background: "white", // Define o fundo como transparente
                                        title: t('View'), // Título do Widget traduzido
                                        icon: null, // Nenhum ícone definido
                                        dropdowns: [
                                            {
                                                data: fullMetrics,
                                                value: infoChoosen,
                                                width: '150px',
                                                functionChange: (value) => setInfoChoosen(value),
                                            },
                                        ],
                                        buttons: [{ key: t("360"), title: t("360º"), onButtonClick: () => toggleCamera(), isActive: orbitCameraVal }]
                                    }}

                                >
                                    <div style={{ height: '660px' }}>
                                        {currentFloor?.value === item?.id ? <StackedFloorsComponent building={item} metric={infoChoosen} setOrbitControls={setOrbitControls} /> :
                                            <FloorVacancyComponent building={item} currentFloor={currentFloor} metric={'incident'} setOrbitControls={setOrbitControls} />}
                                    </div>
                                </Widget>
                            </Col>
                            <Col span={24}>
                                <Row gutter={[16, 16]}>
                                    <Col span={8}>
                                        <Widget
                                            data={{
                                                background: "white",
                                                title: t("Occupation"),
                                                icon: null,

                                                charts: [
                                                    {
                                                        chartType: 'stackedColumnsChartApex',
                                                        chartId: 'stackedColumnsChartApexOne',
                                                        height: '200px',
                                                        data: overviewIndicators?.result?.value?.Occupation ? sereializeOverviewOCccupation(overviewIndicators?.result.value.Occupation, null, t) : []
                                                    }
                                                ],
                                            }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Widget
                                            data={{
                                                background: "white",
                                                title: t("Lighting"),
                                                icon: null,

                                                charts: [
                                                    {
                                                        chartType: 'columnsChartApex',
                                                        chartId: 'columnsChartApexOne',
                                                        height: '200px',
                                                        data: overviewIndicators?.result?.value?.['Light Intensity'] ? serializeIndicators(t('Light Intensity'), overviewIndicators?.result.value['Light Intensity'], 'lm', Theme.color['ligthning']) : []
                                                    }
                                                ],
                                            }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Widget
                                            data={{
                                                background: "white",
                                                title: t("Temperature"),
                                                icon: null,

                                                charts: [
                                                    {
                                                        chartType: 'columnsChartApex',
                                                        chartId: 'columnsChartApexOne',
                                                        height: '200px',
                                                        data: overviewIndicators?.result?.value?.['Temperature'] ? serializeIndicators(t('Temperature'), overviewIndicators?.result.value['Temperature'], 'ºC', Theme.color['temperature-estimated']) : []
                                                    }
                                                ],
                                            }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Widget
                                            data={{
                                                background: "white",
                                                title: t("Humidity"),
                                                icon: null,

                                                charts: [
                                                    {
                                                        chartType: 'columnsChartApex',
                                                        chartId: 'columnsChartApexOne',
                                                        height: '200px',
                                                        data: overviewIndicators?.result?.value?.['Humidity'] ? serializeIndicators(t('Humidity'), overviewIndicators?.result.value['Humidity'], 'g/m3', Theme.color['chart-base-7']) : []
                                                    }
                                                ],
                                            }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Widget
                                            data={{
                                                background: "white",
                                                title: t("Air Quality"),
                                                icon: null,

                                                charts: [
                                                    {
                                                        chartType: 'columnsChartApex',
                                                        chartId: 'columnsChartApexOne',
                                                        height: '200px',
                                                        data: overviewIndicators?.result?.value?.['CO2'] ? serializeIndicators(t('CO2'), overviewIndicators?.result.value['CO2'], 'ppm', Theme.color['co2']) : []
                                                    }
                                                ],
                                            }}
                                        />
                                    </Col>
                                    <Col span={8}>
                                        <Widget
                                            data={{
                                                background: "white",
                                                title: t("Noise"),
                                                icon: null,

                                                charts: [
                                                    {
                                                        chartType: 'columnsChartApex',
                                                        chartId: 'columnsChartApexOne',
                                                        height: '200px',
                                                        data: overviewIndicators?.result?.value?.['Sound Level'] ? serializeIndicators(t('Sound Level'), overviewIndicators?.result.value['Sound Level'], 'dB', Theme.color['chart-base-9']) : []
                                                    }
                                                ],
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            ) : (
                <div style={{ height: 'inherit', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <Spinner stroke="green" />
                </div>
            )}
        </PageContent>
    )
}

const sereializeOverviewOCccupation = (data, unit, t) => {
    const series = [];
    const categories = [];

    Object.entries(data).map((entry) => {
        const [key, value] = entry;

        Object.entries(value).map((valueEntry) => {
            const foundObject = series.find(obj => obj.name === t(valueEntry[0]));
            if (foundObject) {
                foundObject.data.push(valueEntry[1]);
            } else {
                series.push({ name: t(valueEntry[0]), data: [valueEntry[1]] });
            }
        })
        categories.push(t(key));
    })

    return {
        series: series,
        categories: categories,
        xAxisType: null,
        labelFormat: null,
        tooltip: null,
        markerSize: null,
        unit: unit ?? "",
        columnWidth: 40,
        xAxisLabel: unit ?? "",
        colors: [Theme.color["occupation"], Theme.color["occupation-free"]],
    };
};

const serializeIndicators = (indicator, data, unit, barColor) => {
    const series = [
        {
            name: indicator,
            data: [],
        },
    ];

    Object.entries(data.data).map((entry) => {
        const [key, value] = entry;

        series[0].data.push({
            x: key,
            y: value.toFixed(1),
        });
    });

    return {
        series: series,
        categories: [],
        xAxisType: "",
        labelFormat: "",
        tooltip: null,
        unit: unit ?? "",
        xAxisLabel: null,
        yAxisLabel: unit ?? "",
        colors: [barColor],
        formatterType: null,
        tickAmount: 12,
        filename: "Gráfico exportado",
        headerValue: "valores",
        headerCategory: "categorias",
        showTooltipTitle: false,
        strokeWidth: 10,
    };
};
